import { t, Trans } from "@lingui/macro";
import React, { useState } from "react";
import CreateRoomModal from "./CreateRoomModal";
import WorkspaceCreateModal from "../workspaces/WorkspaceCreateModal";
import WorkspaceJoinModal from "../workspaces/WorkspaceJoinModal";
import { useAppUIContext } from "../../context/AppUIContext";
import { MessageSquarePlus } from "lucide-react"; // Import icon
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "../../components/ui/dropdown-menu";
import { Button } from "../../components/ui/button";
import { useToast } from "../../hooks/use-toast";

export const CreatePopover: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [showCreateRoomModal, setShowCreateRoomModal] = useState(false);
  const [showCreateWSModal, setShowCreateWSModal] = useState(false);
  const [showJoinWSModal, setShowJoinWSModal] = useState(false);
  const { workspaces } = useAppUIContext();
  const { toast } = useToast();

  return (
    <>
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger asChild>
          <Button variant="icon-box" size="icon" className="shrink-0 hover:bg-slate-100">
            <MessageSquarePlus />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" side="bottom" sideOffset={8}>
          <DropdownMenuItem onClick={() => setShowCreateWSModal(true)} className="cursor-pointer">
            <Trans>Create a workspace</Trans>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => setShowJoinWSModal(true)} className="cursor-pointer">
            <Trans>Join a workspace</Trans>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={createRoom} className="cursor-pointer">
            <Trans>Create a room</Trans>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <CreateRoomModal show={showCreateRoomModal} setShow={setShowCreateRoomModal} workspaceId={null} />
      <WorkspaceCreateModal show={showCreateWSModal} setShow={setShowCreateWSModal} />
      <WorkspaceJoinModal show={showJoinWSModal} setShow={setShowJoinWSModal} />
    </>
  )

  function createRoom() {
    if (workspaces.length === 0) {
      toast({
        title: t`Notification`,
        description: t`You must create a workspace before creating a room.`,
        variant: "destructive"
      });
    } else {
      setShowCreateRoomModal(true)
    }
  }
}

export default CreatePopover;